import React, { useEffect, useRef, useCallback } from "react";
import { connect } from "react-redux";
import { getControls, selectControls, resetControls } from "../search.ducks";
import { getRecentSearchQuery, getUrlParams } from "../../../services";
import { selectFilteredCategories } from "../../../containers/App/selectors";
import { mapCategoryToEn } from "../../LanguageMapper";
import { ControlType, PageRoute, QueryParam } from "../../../models";
import history from "../../../history";

// eslint-disable-next-line max-lines-per-function
export default (Com, getConfigData) => {
  const SearchControlComponent = props => {
    const {
      isMobile,
      controls,
      module,
      category,
      location,
      getControls,
      resetControls
    } = props;

    const queryParams = useRef({});

    useEffect(() => {
      const isSearchPage = history.location.pathname.includes(PageRoute.search);
      const isUserPage = history.location.pathname.includes(PageRoute.user);
      const query = isSearchPage ? getUrlParams(location.search, QueryParam.searchQuery) : (isUserPage ? {} : getRecentSearchQuery(category));
      queryParams.current = { ...query };

      const categoryFromQeury = queryParams.current.category;
      const categoryFromPath = (location && location.pathname && location.pathname.split("/").length > 2) ? location.pathname.split("/")[2] : null;

      // @ts-ignore
      setCategoryState(categoryFromQeury || categoryFromPath, true);
    }, [
      location.search || location.pathname || module
    ]);

    const resetFields = callback => {
      const { module, categoryName, category, location } = props;

      const query = getUrlParams(location.search, QueryParam.searchQuery);
      const selectedCategory = query && query.category;
      resetControls(
        module,
        mapCategoryToEn(selectedCategory, module) || categoryName || mapCategoryToEn(category, module),
        queryParams.current,
        getConfigData
      );
      callback && callback();
    };

    const setCategoryState = (passedCategory, isDidMount = false) => {
        // @ts-ignore
      queryParams.current.category = passedCategory || category;

      // On mobile:
      // - mount/URL-driven loads are handled by SearchSection's own useEffect
      // - on the search page, user-initiated changes trigger `history.replace`
      //   which re-fires SearchSection's useEffect with the new URL params
      // Other pages (seller, user, category home) keep the modal open and
      // don't change the URL, so we must dispatch here to load controls for
      // the newly picked subcategory.
      if (isMobile) {
        const isSearchPage = history.location.pathname.includes(PageRoute.search);
        if (isDidMount || isSearchPage) return;
      }

      if (isDidMount || (module && passedCategory) || !module) {
          getControls(
            module,
            passedCategory || category,
            queryParams.current,
            getConfigData
          );
        }
    };

    const handleCategoryChange = async (category, isInit) => {
      const { onSubmit, module } = props;

      queryParams.current = {};

      if (isInit) {
        queryParams.current = { category };
        setCategoryState(category);
      } else {
        const searchConfig = await getConfigData(module);
        const categoryConfig = searchConfig.categories.find(
          c => c.name === category
        );

        if (categoryConfig) {
          setCategoryState(category);
        } else {
          onSubmit({ category });
        }
      }
    };

    const normaliseSearchValues = useCallback(values => {
      const fields = Array.isArray(controls) ? controls.map(controlGroup => {
        return controlGroup.controls;
      }).reduce((acc, val) => acc.concat(val), []) : [];

      if (values && fields) {

        fields.forEach(field => {
          let shouldSwitch = false;

          // switch from/to data in range type fields if from is greater than to
          if (field.type === ControlType.range) {

            if (field.isDateValue) {
              shouldSwitch = values[field.fromField] && values[field.toField] && new Date(values[field.fromField]) > new Date(values[field.toField]);
            }

            if (field.numberFormatted){
              shouldSwitch = values[field.fromField] && values[field.toField] && +values[field.fromField] > +values[field.toField];
            }

            if (shouldSwitch ) {
              values = {
                ...values,
                [field.fromField]: values[field.toField],
                [field.toField]: values[field.fromField]
              }
            }
          }
        });
      }

      return values;
    }, [controls]);

    return (
      <Com
        onCategoryChange={handleCategoryChange}
        resetFields={resetFields}
        normaliseSearchValues={normaliseSearchValues}
        {...props}
      />
    );
  };

  SearchControlComponent.defaultProps = {
    controls: [],
    location: {},
    module: "",
  };

  return connect(
    state => ({
      controls: selectControls(state),
      filteredCategories: selectFilteredCategories(state),
    }),
    {
      getControls,
      resetControls,
    }
  )(SearchControlComponent);
};



// WEBPACK FOOTER //
// ./src/routes/Search/HOCs/handleSearchControl.tsx